var map = {
	"./arrow-left.svg": 5839,
	"./arrow-right.svg": 7402,
	"./cart.svg": 6162,
	"./chevron-left.svg": 8893,
	"./chevron-right.svg": 3984,
	"./close.svg": 9580,
	"./left.svg": 6931,
	"./mail.svg": 493,
	"./menu.svg": 1997,
	"./minus.svg": 96,
	"./phone.svg": 9156,
	"./play.svg": 9878,
	"./plus.svg": 8392,
	"./right.svg": 5686,
	"./search.svg": 5460,
	"./star.svg": 9800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3216;